import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as messagesActions from '../shared/actions/messagesActions';
import PropTypes from 'prop-types';
import Select from '../../../../shared/components/Select';
import { buildOptions } from '../../../../shared/utils/OptionsManager';
import Row from '../../../../shared/components/Row';

class AddMessage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            messageToSend: '',
            showMessageError: false,
            selectedTargetCompanyId: -1,
            showSelectedTargetCompanyIdError: false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { targetCompanies } = this.props;
        if ( !prevProps.targetCompanies || prevProps.targetCompanies.length === 0 &&
            targetCompanies && targetCompanies.length === 1 ) {
            this.setState({ selectedTargetCompanyId: targetCompanies[0].id() });
        }
    }

    onSubmit = (event) => {
        const {
            messageToSend,
            selectedTargetCompanyId,
        } = this.state;

        event.preventDefault();

        if ( !messageToSend || messageToSend.trim().length === 0 ) {
            this.setState({ showMessageError: true });
            return;
        }
        if ( selectedTargetCompanyId === -1 ) {
            this.setState({ showSelectedTargetCompanyIdError: true });
            return;
        }

        this.props.messagesActions.sendMessage(messageToSend, selectedTargetCompanyId, this.props.queryIds, () => {
            this.props.addMessageSuccess();
            this.setState({ messageToSend: '' });
        });
    };

    handleMessageChange = (event) => {
        const message = event.target.value;
        this.setState({
            messageToSend: message,
            showMessageError: !message || message.trim().length === 0,
        });
    };

    handleSelectTargetCompany = (event) => {
        const value = parseInt(event.target.value);
        this.setState({
            selectedTargetCompanyId: value,
            showSelectedTargetCompanyIdError: value === -1,
        });
    };

    render() {
        const { targetCompanies } = this.props;
        const {
            showMessageError,
            selectedTargetCompanyId,
            showSelectedTargetCompanyIdError,
        } = this.state;
        const targetCompaniesOptions = (targetCompanies || []).map(tc => ( { name: tc.name(), value: tc.id() } ));
        const disabledSelectTargetCompany = targetCompaniesOptions.length === 1;

        return (
            <section className="write-message">
                <form onSubmit={this.onSubmit}>
                    <div className="form-group">
                        <Row>
                            <div className={'col-md-6'}>
                                <div className="form-group ">
                                    <label>{I18nUtils.tr('TR_DESTINATARIO')}</label>
                                    <Select
                                        className={'form-control'}
                                        options={targetCompaniesOptions}
                                        value={selectedTargetCompanyId}
                                        disabled={disabledSelectTargetCompany}
                                        onChange={this.handleSelectTargetCompany}
                                    />
                                    {showSelectedTargetCompanyIdError &&
                                        <label className="error">
                                            {I18nUtils.tr('TR_CAMPO_OBLIGATORIO')}
                                        </label>}
                                </div>
                            </div>
                        </Row>
                        <div className="form-line">
                            <label htmlFor="write" className="">{I18nUtils.tr('TR_ESCRIBIR_MENSAJE')}</label>
                            <textarea
                                rows="3"
                                name="address"
                                id="write"
                                className="form-control no-resize auto-growth"
                                value={this.state.messageToSend}
                                onChange={this.handleMessageChange}
                            > </textarea>
                            {showMessageError &&
                                <label className="error">
                                    {I18nUtils.tr('TR_CAMPO_OBLIGATORIO')}
                                </label>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 pull-right">
                            <div className="form-group">
                                <button type="submit" className="btn btn-default btn-block btn-sm waves-effect">
                                    {I18nUtils.tr('TR_ENVIAR')}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        );
    }
}

const mapStateToProps = () => ( {} );

const mapDispatchToProps = dispatch => ( {
    messagesActions: bindActionCreators(messagesActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(AddMessage);

AddMessage.propTypes = {
    addMessageSuccess: PropTypes.func.isRequired,
    queryIds: PropTypes.any,
    targetCompanies: PropTypes.func.isRequired,
};

AddMessage.defaultProps = {
    addMessageSuccess: () => {},
    queryIds: {},
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/card/AddMessage.jsx